// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"acd1ae74","287":"901f9712","290":"15a7eece","344":"28a1cb37","550":"14bccca6","608":"c4620776","841":"052ed157"}[chunkId] + ".chunk.js";
};